// extracted by mini-css-extract-plugin
export const section = "firstImage-module--section--1npR9";
export const imageSection = "firstImage-module--imageSection--30DBS";
export const container = "firstImage-module--container--2rV4f";
export const pageContent = "firstImage-module--pageContent--2cjxQ";
export const footer = "firstImage-module--footer--33W6W";
export const modal = "firstImage-module--modal--1t82r";
export const imageContainer = "firstImage-module--imageContainer--1sJk5";
export const title = "firstImage-module--title--1ZBhz";
export const subtitle = "firstImage-module--subtitle--1neO9";